import React, {lazy, Suspense} from 'react';
import {createRoot} from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import Loading from 'components/layout/Loading';
import {fetchAllConfig} from './import-config';
//import * as serviceWorker from './serviceWorker';

fetchAllConfig().then(() => {
  const App = lazy(() => import('./App'));
  const container = document.getElementById('root');
  const root = createRoot(container);
  return root.render(
    <Suspense fallback={<Loading />}>
      <App />
    </Suspense>
  );
});

//serviceWorker.register();

reportWebVitals();
